import { IStore } from '..';
import type { TSideNavReducerState } from '../../app/types/sideNavTypes';

export const getSideNavState = (state: IStore): TSideNavReducerState =>
  state.sideNavReducer;
